import React from 'react';
import { FormattedMessage } from 'react-intl';
import PersonalInfoStep from './personalInfo';
import DocumentStep from './documentStep';
import DoneStep from './done';
import RejectedStep from './rejected';
import { getDocuments } from '../utilities';

export function getSteps(controls, progress, props) {
    const { i9 } = props;
    const { next } = controls;
    const { branch } = progress;
    const documents = getDocuments(props);
    let rest = { ...props, ...controls };

    const steps = [
        <PersonalInfoStep
            onSubmit={() => next(1, i9.id, branch)}
            title={<FormattedMessage id={'i9.onboardint.title.personalInfo'} defaultMessage={'Enter Your Information'} />}
            {...rest}
        />,
        ...documents.map((doc, i) => (
            <DocumentStep
                key={i}
                onSubmit={values => next(2 + i, i9.id, values.branch)}
                document={doc}
                title={<FormattedMessage id={'i9.onboardint.title.documents'} defaultMessage={'Verify Document'} />}
                {...rest}
            />
        ))
    ];

    return [
        ...steps,
        branch === 'witness_rejected' ? (
            <RejectedStep title={<FormattedMessage id={'i9.onboardint.title.rejected'} defaultMessage={'Thank you for your time'} />} {...rest} />
        ) : (
            <DoneStep title={<FormattedMessage id={'i9.onboardint.title.done'} defaultMessage={'Almost Done'} />} {...rest} />
        )
    ];
}



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/index.jsx